import { render, staticRenderFns } from "./UserGroupTagGroup.vue?vue&type=template&id=52911a25&scoped=true&"
import script from "./UserGroupTagGroup.vue?vue&type=script&lang=ts&"
export * from "./UserGroupTagGroup.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupTagGroup.vue?vue&type=style&index=0&id=52911a25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52911a25",
  null
  
)

export default component.exports